<template>
    <div class="notes-dialog">
        <el-dialog :visible.sync="notesOpen" 
        append-to-body
        width="80vw"
        :close-on-click-modal="true"
        class="send-modal">
            <div slot="title" class="bucket-header">
                <img class="event-chevron" style="width: 57px" :src="require('../image/ctc-other.png')" /> 
                {{ questionnaireTitle }}
                <span class="bucket-provider">
                    Responded on {{ questionnaireDate }}
                </span>
                <span class="flex-full"></span>


                <button size="medium" class="questionnaire-copy-button" @click="copyToClip()">
                    <i class="el-icon-copy-document"></i> Copy
                </button>
            </div>
            <div class="dialog-body">
                <div class="notes">
                    <TextEdit 
                        :key="renderKey"
                        class="text-edit expanded"
                        v-model="copyNotes"
                    ></TextEdit>
                </div>
            </div>
        </el-dialog>
        <button v-if="type === 'text'" @click="notesOpen = true" class="questionnaire-view-button" type="text" size="medium">
            <i class="el-icon-view"></i> View
        </button>
        <img v-else-if="type === 'icon'" @click="notesOpen = true" class="expand-icon" :src="require('../image/expand-icon.png')" />
    </div>
    
</template>

<script>
import { mapActions } from 'vuex'

import CopyMixin from './mixin/copy'

import TextEdit from '@/module/component/TextEdit'

export default {
    name: 'other-notes-dialog',

    mixins: [CopyMixin],

    props: {
        patient: {
            type: Object,
            required: true
        },
        notes: {
            type: String,
            required: true
        },
        questionnaireTitle: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        questionnaireDate: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        }
    },


    data() {
        return {
            notesOpen: false,
            copyNotes: this.notes.replaceAll('\n', '<br>'),
            pushing: false,

            renderKey: 0,
            foundEmpty: false
        }
    },

    methods: {
        ...mapActions('provider', ['pushNoteCategory', 'loadPatient']),
        copyToClip() {
            this.copy(this.copyNotes)
        }
    },

    components: {
        TextEdit
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.dialog-body {
    background-color: #F8F8F8;
    margin-top: -20px;
    width: calc(80vw - 40px);
    padding: 20px;
    border-radius: 7px;
}

.el-checkbox {
    font-weight: 600;
}

.bucket-header {
    background-color: transparent;
}
.notes-dialog {
    margin-top: -20px;
}
.questionnaire-view-button, .questionnaire-view-button:hover {
    float: right;
    background-color: #EEEEEE;
    font-size: 13px;
    border: none;
    margin-left: 10px;
    border-radius: 5px;
    padding: 6px 8px !important;
    i {
        font-size: 13px;
		margin-right: 3px;
    }
}
.push-btn-container {
    float: right;
}
.push-button, .push-button:hover {
    font-size: 13px;
    font-weight: 500;
    color: #833e93;
    height: 28px;
    margin-left: 10px;
    background-color: #FAF5FC;
    border: 1px solid #833e93;
    border-radius: 5px;
    padding: 7px 8px !important;
    i {
        font-size: 11px;
        color: #833e93;
    }
}
.expand-icon {
    height: 20px;
    width: 20px;
    float: right;
    cursor: pointer;
}
.notes {
    background-color: #ffffff;
    border-radius: 10px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 24px;
}
.event-head {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 10px;
    span:first-child {
        padding-left: 0;
    }
    span {
        padding: 0px 12px;
    }
}
.questionnaire-section {
    word-break: break-word;
    margin-bottom: 12px;
}

.info {
    display: flex;
    background-color: #FFF3E3;
    color: #FA9E25;
    margin-bottom: -10px;
    padding: 8px 12px;
    font-size: 12px;
    max-width: 200px;
    img {
        height: 10px;
        width: 10px;
        margin-right: 5px;
    }
}

.dropdwn-cnt{
    display: inline-block;
    height: 45px !important;
    min-width: 250px;
}

.option-title {
    display: inline-block;
    margin-top: 5px;
    width: 70%;
    line-height: 1.4;
}
.timestamp{
    color: #999999;
    font-size: 10px;
    width: 35%;
    position: absolute;
    right: 10px;
    display: inline-block;
    text-align: right;

    span {
        height: 15px;
        display: block;
    }
}
.inl-blk {
    display: inline-block;
}
.pop-btn-grp {
    margin-left: 20px
}
</style>


<style scoped>
.send-modal >>> .el-dialog__headerbtn {
    top: 0px;
    right: -40px;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 5px 5px 3px 5px;
}
.send-modal >>> .el-dialog__close:hover {
	font-weight: bold;
}
.send-modal >>> .el-dialog__close {
	color: #333333;
    font-size: 15px;
    font-weight: 500;
}
.send-modal >>> .el-dialog__headerbtn:hover .el-dialog__close {
	font-size: 15px;
    font-weight: 500;
}
.cust-pop-class {
    min-width: 520px;
}
.text-edit >>> b{
    color: #833e93;
}
.footer-btn >>> span {
    display: flex;
    align-items: center;
}
</style>
